import TicketTrendsChart from './TicketTrendsChart';
import PerformanceMetrics from './PerformanceMetrics';
import LevelWisePerformance from './LevelWisePerformance';

export default function DashboardView({
    datas,
  PriorityValues,
  SttausValues,
  Client,
  range,
  date,
  Client_id,
   setdates,
    setranges,
  setSelectedRange
}) {
  return (
 <div className="dashboard-layout">
  <div className="dashboard-row">
    <div className="left-panel">
      <TicketTrendsChart 
        datas={datas}
  PriorityValues={PriorityValues}
  SttausValues={SttausValues}
  Client={Client}
    date={date}
                     Client_id={Client_id}
         setdates={setdates}
      setranges={setranges}
  setSelectedRange={setSelectedRange}
      />
    </div>
    <div className="right-panel">
      <PerformanceMetrics range={range} 
                           Client_id={Client_id}

        datas={datas}
  PriorityValues={PriorityValues}
  SttausValues={SttausValues}
  Client={Client}
  date={date}
      />
      <LevelWisePerformance 
          datas={datas}
  PriorityValues={PriorityValues}
  SttausValues={SttausValues}
  Client={Client}
range={range} 
  date={date}
                     Client_id={Client_id}

  
      />
    </div>
  </div>
</div>

  );
}
